import { Pipe, PipeTransform } from '@angular/core'
import { PatientSexes } from '@mmx/shared'

@Pipe({ name: 'sex', standalone: false })
export class SexPipe implements PipeTransform {
  transform(sex?: PatientSexes) {
    switch (sex) {
      case 'F':
        return 'Female'
      case 'M':
        return 'Male'
      case 'A':
      case 'O': {
        return 'Other'
      }
      default: {
        return 'Unspecified'
      }
    }
  }
}
